import $ from 'jquery';

function PartnerStoresInit() {
  var form = $("#partner-store-filter-form");
  if(form.length > 0){
    $("#county").change(function(){
      form.submit();
    });
    $("#city").change(function(){
      form.submit();
    });
  }
}

function initStoresMap(){

  var myLatLng = {lat: 47.49, lng: 19.05};
  var map = new google.maps.Map(document.getElementById("map-div"), {
    zoom: 10,
    center: myLatLng
  });

  var markers = [];
  var infoWindow = new google.maps.InfoWindow({
    content: "loading..."
  });

  for (var i in markerObjs) {
      var obj = markerObjs[i];
      var contentString = "<strong>" + obj.name + "</strong><br />" + obj.address + "<br />";
      if(obj.path){
        contentString+="<a href='" + obj.path + "'>Részletek</a>";
      }
      var marker = new google.maps.Marker({
        position: obj,
        map: map,
        title: obj.name,
        contentString: contentString,
        infoWindow : infoWindow
      });
      marker.addListener('click', function () {
        this.infoWindow.setContent(this.contentString);
        this.infoWindow.open(this.map, this);
      });
      markers[i] = marker;
    }
    //set map to center by markers
    if (markers.length > 0) {
      var bounds = new google.maps.LatLngBounds();
      for (var i = 0; i < markers.length; i++) {
        bounds.extend(markers[i].getPosition());
      }
      map.fitBounds(bounds);
      if(markers.length == 1){
        var listener = google.maps.event.addListener(map, "idle", function() {
          console.log("run listener");
          this.setZoom(15);
          google.maps.event.removeListener(listener);
        });
      }

    }


}

$(document).ready(function () {
  console.log("frontend: partner store ready");

  PartnerStoresInit();
});
